import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import styles from './styles.css';

@autobind
export default class Textarea extends Component {
    static propTypes = {
        value: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
    };

    handleChange(event) {
        this.props.onChange(event.target.value);
    }

    render() {
        return (
            <textarea
                className={classNames(styles.root, {
                    [styles.disabled]: this.props.disabled,
                })}
                value={this.props.value}
                placeholder={this.props.placeholder}
                disabled={this.props.disabled}
                onChange={this.handleChange}
                onBlur={this.props.onBlur}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./components/forms/textarea/index.js